// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"a8b7097b","257":"c14e9a20","579":"341899e1","587":"bf576021","655":"09175274","787":"31dddc54","927":"efc80e23"}[chunkId] + ".chunk.js";
};